import React, { useState } from "react";
import { Collapse } from "react-bootstrap";

/**
 * SectionCard — a collapsible bordered section used to group
 * related fields / content within a form. Provides a consistent
 * visual rhythm and an optional section-level toolbar slot.
 *
 * Props:
 *   icon, title             — header content
 *   tools                   — right-slot toolbar (section-level actions)
 *   defaultOpen (true)      — initial collapsed state
 *   collapsible (true)      — whether user can collapse
 *   accent (false)          — tinted header for primary sections
 *   bodyPadding             — override body padding
 */
const SectionCard = ({
  icon,
  title,
  tools,
  defaultOpen = true,
  collapsible = true,
  accent = false,
  children,
  bodyPadding,
  className = ""
}) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={`ds-section-card ${accent ? "ds-section-card--accent" : ""} ${className}`}>
      <div
        className="ds-section-card__header"
        onClick={() => collapsible && setOpen(!open)}
        role={collapsible ? "button" : undefined}
        aria-expanded={collapsible ? open : undefined}
      >
        <div className="ds-section-card__title">
          {icon && <i className={`bi ${icon}`} />}
          {title}
        </div>
        <div className="d-flex align-items-center gap-2">
          {tools && (
            <div
              className="ds-section-card__tools"
              onClick={(e) => e.stopPropagation()}
            >
              {tools}
            </div>
          )}
          {collapsible && (
            <i className={`bi ${open ? "bi-chevron-up" : "bi-chevron-down"} text-muted`} />
          )}
        </div>
      </div>

      <Collapse in={open || !collapsible}>
        <div>
          <div className="ds-section-card__body" style={bodyPadding ? { padding: bodyPadding } : undefined}>
            {children}
          </div>
        </div>
      </Collapse>
    </div>
  );
};

export default SectionCard;
